import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ScoreStatus } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BrandM, LabelS } from '@sorare/core/src/atoms/typography';
import { Score } from '@sorare/core/src/components/scoring/Score';

import { TutorialBezel } from '../../TutorialBezel';
import warriorsLogo from './assets/warriorsLogo.png';
import cutPlayerCard from '../../assets/cutPlayerCard.png';

const Img = styled.img`
  position: relative;
  bottom: calc(-1 * var(--double-unit));
  width: calc(12 * var(--unit));
  height: calc(100% + var(--double-unit));
  object-fit: cover;
`;
const Logo = styled.img`
  width: var(--triple-unit);
  height: var(--triple-unit);
  object-fit: contain;
`;
const ScoreWrapper = styled(Vertical)`
  align-items: flex-start;
`;

export const Success = () => {
  return (
    <TutorialBezel color="var(--c-score-high)">
      <Vertical gap={2.5} center>
        <Vertical center className="text-center">
          <FormattedMessage
            id="Success.title2"
            defaultMessage="<title>Hit the target</title><description>With a specific player to win!</description>"
            values={{
              title: chunks => <BrandM>{chunks}</BrandM>,
              description: chunks => (
                <BodyM color="var(--c-nd-600)">{chunks}</BodyM>
              ),
            }}
          />
        </Vertical>
        <Horizontal gap={2}>
          <Img src={cutPlayerCard} alt="" />
          <ScoreWrapper gap={0.5}>
            <Horizontal center>
              <LabelS bold color="var(--c-nd-600)">
                <FormattedMessage
                  id="QuickPlayTutorialDialog.success.scoreVs"
                  defaultMessage="Score vs"
                />
              </LabelS>
              <Logo src={warriorsLogo} />
            </Horizontal>
            <Score
              hideReviewing
              shape="PILL"
              score={60}
              scoreStatus={ScoreStatus.FINAL}
              scoreType="PLAYER_SCORE"
            />
          </ScoreWrapper>
        </Horizontal>
      </Vertical>
    </TutorialBezel>
  );
};
